// FRF TODO refactor to load conditionally
import './animation-loader.svg'
import './icon-404.svg'
import './icon-500.svg'
import './icon-add.svg'
import './icon-calendar.svg'
import './icon-category-shield.svg'
import './icon-check.svg'
import './icon-chevron-down.svg'
import './icon-chevron-left.svg'
import './icon-chevron-right.svg'
import './icon-chevron-up.svg'
import './icon-close.svg'
import './icon-clock.svg'
import './icon-copylink.svg'
import './icon-date.svg'
import './icon-detailtrigger.svg'
import './icon-download.svg'
import './icon-duration.svg'
import './icon-edit.svg'
import './icon-email.svg'
import './icon-exclamation.svg'
import './icon-explainer.svg'
import './icon-flute.svg'
import './icon-football-field.svg'
import './icon-football.svg'
import './icon-formation.svg'
import './icon-full-star.svg'
import './icon-home.svg'
import './icon-homefull.svg'
import './icon-image.svg'
import './icon-kebabmenu.svg'
import './icon-knvb.svg'
import './icon-knvbcup.svg'
import './icon-live.svg'
import './icon-logout.svg'
import './icon-menu.svg'
import './icon-oranje.svg'
import './icon-pause.svg'
import './icon-phone.svg'
import './icon-play.svg'
import './icon-print.svg'
import './icon-profile.svg'
import './icon-pylon.svg'
import './icon-reset.svg'
import './icon-settings.svg'
import './icon-share.svg'
import './icon-stadium.svg'
import './icon-substitute.svg'
import './icon-tag.svg'
import './icon-team.svg'
import './icon-thin-arrow-left.svg'
import './icon-thin-arrow-right.svg'
import './icon-time.svg'
import './icon-tips.svg'
import './icon-url.svg'
import './icon-user.svg'
import './icon-video.svg'
import './icon-voetbalnl.svg'
import './image-drawing-indoor.svg'
import './image-drawing.svg'
import './logo-facebook.svg'
import './logo-instagram.svg'
import './logo-linkedin.svg'
import './logo-rss.svg'
import './logo-twitter.svg'
import './logo-youtube.svg'
import './rating-exerciseMovement.svg'
import './rating-exercisePrevention.svg'
import './rating-exerciseReality.svg'
import './formation-background.svg'
import './symbol-flute.svg'

if (process.env.NEXT_PUBLIC_THEME === 'frf' && process.env.NEXT_PUBLIC_RINUS_DEFAULT_SPORT === 'football') {
  import('./logo-frf--loader.svg')
  import('./logo-frfaccount.svg')
  import('./logo-frfnl.svg')

  import('./frf/icon-playershirt.svg')
  import('./frf/icon-keepershirt.svg')
  import('./frf/logo-frf.svg')
  import('./frf/logo-reversed.svg')
  import('./frf/logo-frf--mobile.svg')
  import('./frf/homepage-player.svg')
  import('./frf/seasons-01-01.svg')
  import('./frf/seasons-01-02.svg')
  import('./frf/seasons-01-03.svg')
  import('./frf/seasons-02-01.svg')
  import('./frf/seasons-02-02.svg')
  import('./frf/seasons-02-03.svg')
  import('./frf/seasons-03-01.svg')
  import('./frf/seasons-03-02.svg')
  import('./frf/seasons-03-03.svg')
  import('./frf/seasons-04-01.svg')
  import('./frf/seasons-04-02.svg')
  import('./frf/seasons-04-03.svg')
  import('./frf/symbol-addexercise.svg')
  import('./frf/symbol-addtraining.svg')
  import('./frf/symbol-addtrainingplan.svg')
  import('./frf/symbol-addmatch.svg')
  import('./frf/symbol-ball.svg')
  import('./frf/symbol-goal-indoor.svg')
  import('./frf/symbol-goal-large.svg')
  import('./frf/symbol-goal-medium.svg')
  import('./frf/symbol-goal-small.svg')
  import('./frf/symbol-lightbulb.svg')
  import('./frf/symbol-overview-exercises.svg')
  import('./frf/symbol-overview-programs.svg')
  import('./frf/symbol-overview-trainings.svg')
  import('./frf/symbol-pawn.svg')
  import('./frf/symbol-pawns.svg')
  import('./frf/symbol-printer.svg')
  import('./frf/symbol-cone.svg')
  import('./frf/symbol-rating.svg')
  import('./frf/symbol-shirt.svg')
  import('./frf/symbol-shirts.svg')
  import('./frf/symbol-trainers-field.svg')
  import('./frf/symbol-training.svg')
}

if (process.env.NEXT_PUBLIC_THEME === 'fmf' && process.env.NEXT_PUBLIC_RINUS_DEFAULT_SPORT === 'football') {
  import('./logo-fmf--loader.svg')
  import('./logo-fmfaccount.svg')
  import('./logo-fmfnl.svg')
  import('./fmf/icon-playershirt.svg')
  import('./fmf/icon-keepershirt.svg')
  import('./fmf/logo-fmf.svg')
  import('./fmf/logo-reversed.svg')
  import('./fmf/logo-fmf--mobile.svg')
  import('./fmf/homepage-player.svg')
  import('./fmf/seasons-01-01.svg')
  import('./fmf/seasons-01-02.svg')
  import('./fmf/seasons-01-03.svg')
  import('./fmf/seasons-02-01.svg')
  import('./fmf/seasons-02-02.svg')
  import('./fmf/seasons-02-03.svg')
  import('./fmf/seasons-03-01.svg')
  import('./fmf/seasons-03-02.svg')
  import('./fmf/seasons-03-03.svg')
  import('./fmf/seasons-04-01.svg')
  import('./fmf/seasons-04-02.svg')
  import('./fmf/seasons-04-03.svg')
  import('./fmf/symbol-addexercise.svg')
  import('./fmf/symbol-addtraining.svg')
  import('./fmf/symbol-addtrainingplan.svg')
  import('./fmf/symbol-addmatch.svg')
  import('./fmf/symbol-ball.svg')
  import('./fmf/symbol-goal-indoor.svg')
  import('./fmf/symbol-goal-large.svg')
  import('./fmf/symbol-goal-medium.svg')
  import('./fmf/symbol-goal-small.svg')
  import('./fmf/symbol-lightbulb.svg')
  import('./fmf/symbol-overview-exercises.svg')
  import('./fmf/symbol-overview-programs.svg')
  import('./fmf/symbol-overview-trainings.svg')
  import('./fmf/symbol-pawn.svg')
  import('./fmf/symbol-pawns.svg')
  import('./fmf/symbol-printer.svg')
  import('./fmf/symbol-cone.svg')
  import('./fmf/symbol-rating.svg')
  import('./fmf/symbol-shirt.svg')
  import('./fmf/symbol-shirts.svg')
  import('./fmf/symbol-trainers-field.svg')
  import('./fmf/symbol-training.svg')
}

if (process.env.NEXT_PUBLIC_THEME === 'knvb' && process.env.NEXT_PUBLIC_RINUS_DEFAULT_SPORT === 'football') {
  import('./knvb/homepage-player.svg')
  import('./knvb/icon-knvb.svg')
  import('./knvb/icon-knvbcup.svg')
  import('./knvb/icon-playershirt.svg')
  import('./knvb/icon-keepershirt.svg')
  import('./knvb/logo-reversed.svg')
  import('./knvb/logo-knvbnl.svg')
  import('./knvb/logo-knvb.svg')
  import('./knvb/logo-knvbaccount.svg')
  import('./knvb/logo-knvb--mobile.svg')
  import('./knvb/logo-knvb--loader.svg')
  import('./knvb/logo-rinus-full.svg')
  import('./knvb/logo-rinus.svg')
  import('./knvb/seasons-01-01.svg')
  import('./knvb/seasons-01-02.svg')
  import('./knvb/seasons-01-03.svg')
  import('./knvb/seasons-02-01.svg')
  import('./knvb/seasons-02-02.svg')
  import('./knvb/seasons-02-03.svg')
  import('./knvb/seasons-03-01.svg')
  import('./knvb/seasons-03-02.svg')
  import('./knvb/seasons-03-03.svg')
  import('./knvb/seasons-04-01.svg')
  import('./knvb/seasons-04-02.svg')
  import('./knvb/seasons-04-03.svg')
  import('./knvb/symbol-addexercise.svg')
  import('./knvb/symbol-addtraining.svg')
  import('./knvb/symbol-addtrainingplan.svg')
  import('./knvb/symbol-addmatch.svg')
  import('./knvb/symbol-ball.svg')
  import('./knvb/symbol-goal-indoor.svg')
  import('./knvb/symbol-goal-large.svg')
  import('./knvb/symbol-goal-medium.svg')
  import('./knvb/symbol-goal-small.svg')
  import('./knvb/symbol-lightbulb.svg')
  import('./knvb/symbol-overview-exercises.svg')
  import('./knvb/symbol-overview-programs.svg')
  import('./knvb/symbol-overview-trainings.svg')
  import('./knvb/symbol-pawn.svg')
  import('./knvb/symbol-pawns.svg')
  import('./knvb/symbol-printer.svg')
  import('./knvb/symbol-cone.svg')
  import('./knvb/symbol-rating.svg')
  import('./knvb/symbol-shirt.svg')
  import('./knvb/symbol-shirts.svg')
  import('./knvb/symbol-trainers-field.svg')
  import('./knvb/symbol-training.svg')
}
if (process.env.NEXT_PUBLIC_THEME === 'louis') {
  import('./louis/homepage-player.svg')
  import('./louis/icon-knvb.svg')
  import('./louis/icon-knvbcup.svg')
  import('./louis/icon-playershirt.svg')
  import('./louis/icon-keepershirt.svg')
  import('./louis/logo-reversed.svg')
  import('./louis/logo-knvbnl.svg')
  import('./louis/logo-louis.svg')
  import('./louis/logo-knvbaccount.svg')
  import('./louis/logo-louis--mobile.svg')
  import('./louis/logo-louis--loader.svg')
  import('./louis/logo-rinus-full.svg')
  import('./louis/logo-rinus.svg')
  import('./louis/seasons-01-01.svg')
  import('./louis/seasons-01-02.svg')
  import('./louis/seasons-01-03.svg')
  import('./louis/seasons-02-01.svg')
  import('./louis/seasons-02-02.svg')
  import('./louis/seasons-02-03.svg')
  import('./louis/seasons-03-01.svg')
  import('./louis/seasons-03-02.svg')
  import('./louis/seasons-03-03.svg')
  import('./louis/seasons-04-01.svg')
  import('./louis/seasons-04-02.svg')
  import('./louis/seasons-04-03.svg')
  import('./louis/symbol-addexercise.svg')
  import('./louis/symbol-addtraining.svg')
  import('./louis/symbol-addtrainingplan.svg')
  import('./louis/symbol-addmatch.svg')
  import('./louis/symbol-ball.svg')
  import('./louis/symbol-goal-indoor.svg')
  import('./louis/symbol-goal-large.svg')
  import('./louis/symbol-goal-medium.svg')
  import('./louis/symbol-goal-small.svg')
  import('./louis/symbol-lightbulb.svg')
  import('./louis/symbol-overview-exercises.svg')
  import('./louis/symbol-overview-programs.svg')
  import('./louis/symbol-overview-trainings.svg')
  import('./louis/symbol-pawn.svg')
  import('./louis/symbol-pawns.svg')
  import('./louis/symbol-printer.svg')
  import('./louis/symbol-cone.svg')
  import('./louis/symbol-rating.svg')
  import('./louis/symbol-shirt.svg')
  import('./louis/symbol-shirts.svg')
  import('./louis/symbol-trainers-field.svg')
  import('./louis/symbol-training.svg')
  import('./louis/symbol-bench.svg')
  import('./louis/symbol-korfbal.svg')
  import('./louis/symbol-long-mat.svg')
  import('./louis/symbol-soft-bal.svg')
  import('./louis/symbol-thick-mat.svg')
  import('./louis/symbol-thin-mat.svg')
  import('./louis/symbol-vaulting-box.svg')
  import('./louis/symbol-lintje.svg')
}
if (process.env.NEXT_PUBLIC_THEME === 'sportwide') {
  import('./sportwide/homepage-player.svg')
  import('./sportwide/icon-knvb.svg')
  import('./sportwide/icon-knvbcup.svg')
  import('./sportwide/icon-playershirt.svg')
  import('./sportwide/icon-keepershirt.svg')
  import('./sportwide/logo-reversed.svg')
  import('./sportwide/logo-knvbnl.svg')
  import('./sportwide/logo-sportwide.svg')
  import('./sportwide/logo-knvbaccount.svg')
  import('./sportwide/logo-sportwide--mobile.svg')
  import('./sportwide/logo-sportwide--loader.svg')
  import('./sportwide/logo-sportwide.svg')
  import('./sportwide/seasons-01-01.svg')
  import('./sportwide/seasons-01-02.svg')
  import('./sportwide/seasons-01-03.svg')
  import('./sportwide/seasons-02-01.svg')
  import('./sportwide/seasons-02-02.svg')
  import('./sportwide/seasons-02-03.svg')
  import('./sportwide/seasons-03-01.svg')
  import('./sportwide/seasons-03-02.svg')
  import('./sportwide/seasons-03-03.svg')
  import('./sportwide/seasons-04-01.svg')
  import('./sportwide/seasons-04-02.svg')
  import('./sportwide/seasons-04-03.svg')
  import('./sportwide/symbol-addexercise.svg')
  import('./sportwide/symbol-addtraining.svg')
  import('./sportwide/symbol-addtrainingplan.svg')
  import('./sportwide/symbol-addmatch.svg')
  import('./sportwide/symbol-overview-exercises.svg')
  import('./sportwide/symbol-overview-programs.svg')
  import('./sportwide/symbol-overview-trainings.svg')
  import('./sportwide/symbol-trainers-field.svg')
  import('./sportwide/symbol-training.svg')
  import('./sportwide/homepage-player.svg')
  import('./sportwide/symbol-ball.svg')
  import('./sportwide/symbol-goal-indoor.svg')
  import('./sportwide/symbol-goal-large.svg')
  import('./sportwide/symbol-goal-medium.svg')
  import('./sportwide/symbol-goal-small.svg')
  import('./sportwide/symbol-lightbulb.svg')
  import('./sportwide/symbol-pawn.svg')
  import('./sportwide/symbol-pawns.svg')
  import('./sportwide/symbol-printer.svg')
  import('./sportwide/symbol-cone.svg')
  import('./sportwide/symbol-rating.svg')
  import('./sportwide/symbol-shirt.svg')
  import('./sportwide/symbol-shirts.svg')
  import('./sportwide/symbol-accommodation.svg')
  import('./sportwide/symbol-agreement.svg')
  import('./sportwide/symbol-association-policy.svg')
  import('./sportwide/symbol-chart.svg')
  import('./sportwide/symbol-club-arbitration.svg')
  import('./sportwide/symbol-club-development.svg')
  import('./sportwide/symbol-contact.svg')
  import('./sportwide/symbol-education.svg')
  import('./sportwide/symbol-email.svg')
  import('./sportwide/symbol-english.svg')
  import('./sportwide/symbol-excercise-making.svg')
  import('./sportwide/symbol-finance.svg')
  import('./sportwide/symbol-fit.svg')
  import('./sportwide/symbol-game-rules.svg')
  import('./sportwide/symbol-green.svg')
  import('./sportwide/symbol-incidents.svg')
  import('./sportwide/symbol-informatie.svg')
  import('./sportwide/symbol-information.svg')
  import('./sportwide/symbol-marketing.svg')
  import('./sportwide/symbol-member.svg')
  import('./sportwide/symbol-person-a.svg')
  import('./sportwide/symbol-person-b.svg')
  import('./sportwide/symbol-person-c.svg')
  import('./sportwide/symbol-person-d.svg')
  import('./sportwide/symbol-player.svg')
  import('./sportwide/symbol-practisemaking.svg')
  import('./sportwide/symbol-pupil-football.svg')
  import('./sportwide/symbol-quiz.svg')
  import('./sportwide/symbol-rules.svg')
  import('./sportwide/symbol-sponsoring.svg')
  import('./sportwide/symbol-timer.svg')
  import('./sportwide/symbol-together.svg')
  import('./sportwide/symbol-together-1.svg')
  import('./sportwide/symbol-together-2.svg')
  import('./sportwide/symbol-video.svg')
  import('./sportwide/symbol-voetbalfit.svg')
  import('./sportwide/symbol-worldcoaches.svg')
  import('./sportwide/symbol-youth-plan.svg')
}

if (process.env.NEXT_PUBLIC_THEME === 'worldcoaches') {
  import('./worldcoaches/homepage-player.svg')
  import('./worldcoaches/icon-knvb.svg')
  import('./worldcoaches/icon-knvbcup.svg')
  import('./worldcoaches/icon-playershirt.svg')
  import('./worldcoaches/icon-keepershirt.svg')
  import('./worldcoaches/logo-reversed.svg')
  import('./worldcoaches/logo-knvbnl.svg')
  import('./worldcoaches/logo-worldcoaches.svg')
  import('./worldcoaches/logo-knvbaccount.svg')
  import('./worldcoaches/logo-worldcoaches--mobile.svg')
  import('./worldcoaches/logo-worldcoaches--loader.svg')
  import('./worldcoaches/logo-worldcoaches.svg')
  import('./worldcoaches/seasons-01-01.svg')
  import('./worldcoaches/seasons-01-02.svg')
  import('./worldcoaches/seasons-01-03.svg')
  import('./worldcoaches/seasons-02-01.svg')
  import('./worldcoaches/seasons-02-02.svg')
  import('./worldcoaches/seasons-02-03.svg')
  import('./worldcoaches/seasons-03-01.svg')
  import('./worldcoaches/seasons-03-02.svg')
  import('./worldcoaches/seasons-03-03.svg')
  import('./worldcoaches/seasons-04-01.svg')
  import('./worldcoaches/seasons-04-02.svg')
  import('./worldcoaches/seasons-04-03.svg')
  import('./worldcoaches/symbol-addexercise.svg')
  import('./worldcoaches/symbol-addtraining.svg')
  import('./worldcoaches/symbol-addtrainingplan.svg')
  import('./worldcoaches/symbol-addmatch.svg')
  import('./worldcoaches/symbol-overview-exercises.svg')
  import('./worldcoaches/symbol-overview-programs.svg')
  import('./worldcoaches/symbol-overview-trainings.svg')
  import('./worldcoaches/symbol-trainers-field.svg')
  import('./worldcoaches/symbol-training.svg')
  import('./worldcoaches/homepage-player.svg')
  import('./worldcoaches/symbol-ball.svg')
  import('./worldcoaches/symbol-goal-indoor.svg')
  import('./worldcoaches/symbol-goal-large.svg')
  import('./worldcoaches/symbol-goal-medium.svg')
  import('./worldcoaches/symbol-goal-small.svg')
  import('./worldcoaches/symbol-lightbulb.svg')
  import('./worldcoaches/symbol-pawn.svg')
  import('./worldcoaches/symbol-pawns.svg')
  import('./worldcoaches/symbol-printer.svg')
  import('./worldcoaches/symbol-cone.svg')
  import('./worldcoaches/symbol-rating.svg')
  import('./worldcoaches/symbol-shirt.svg')
  import('./worldcoaches/symbol-shirts.svg')
  import('./worldcoaches/symbol-accommodation.svg')
  import('./worldcoaches/symbol-agreement.svg')
  import('./worldcoaches/symbol-association-policy.svg')
  import('./worldcoaches/symbol-chart.svg')
  import('./worldcoaches/symbol-club-arbitration.svg')
  import('./worldcoaches/symbol-club-development.svg')
  import('./worldcoaches/symbol-contact.svg')
  import('./worldcoaches/symbol-education.svg')
  import('./worldcoaches/symbol-email.svg')
  import('./worldcoaches/symbol-english.svg')
  import('./worldcoaches/symbol-excercise-making.svg')
  import('./worldcoaches/symbol-finance.svg')
  import('./worldcoaches/symbol-fit.svg')
  import('./worldcoaches/symbol-game-rules.svg')
  import('./worldcoaches/symbol-green.svg')
  import('./worldcoaches/symbol-incidents.svg')
  import('./worldcoaches/symbol-informatie.svg')
  import('./worldcoaches/symbol-information.svg')
  import('./worldcoaches/symbol-marketing.svg')
  import('./worldcoaches/symbol-member.svg')
  import('./worldcoaches/symbol-person-a.svg')
  import('./worldcoaches/symbol-person-b.svg')
  import('./worldcoaches/symbol-person-c.svg')
  import('./worldcoaches/symbol-person-d.svg')
  import('./worldcoaches/symbol-player.svg')
  import('./worldcoaches/symbol-practisemaking.svg')
  import('./worldcoaches/symbol-pupil-football.svg')
  import('./worldcoaches/symbol-quiz.svg')
  import('./worldcoaches/symbol-rules.svg')
  import('./worldcoaches/symbol-sponsoring.svg')
  import('./worldcoaches/symbol-timer.svg')
  import('./worldcoaches/symbol-together.svg')
  import('./worldcoaches/symbol-together-1.svg')
  import('./worldcoaches/symbol-together-2.svg')
  import('./worldcoaches/symbol-video.svg')
  import('./worldcoaches/symbol-voetbalfit.svg')
  import('./worldcoaches/symbol-worldcoaches.svg')
  import('./worldcoaches/symbol-youth-plan.svg')
}

// if (process.env.NEXT_PUBLIC_RINUS_DEFAULT_SPORT === 'handball') {
//   import('./handball/homepage-player.svg')
//   import('./handball/symbol-ball.svg')
//   import('./handball/symbol-goal-indoor.svg')
//   import('./handball/symbol-goal-large.svg')
//   import('./handball/symbol-goal-medium.svg')
//   import('./handball/symbol-goal-small.svg')
//   import('./handball/symbol-lightbulb.svg')
//   import('./handball/symbol-pawn.svg')
//   import('./handball/symbol-pawns.svg')
//   import('./handball/symbol-printer.svg')
//   import('./handball/symbol-cone.svg')
//   import('./handball/symbol-rating.svg')
//   import('./handball/symbol-shirt.svg')
//   import('./handball/symbol-shirts.svg')
// }
